import type { SVGProps } from 'react';

const BackHomeRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32px"
    height="26px"
    viewBox="0 0 32 26"
    fill="none"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>My home marker</title>
    <defs>
      <path
        d="M18.6449997,9.86315789 L13.6,5.19649123 C13.2444444,4.93450292 12.7555556,4.93450292 12.4,5.19649123 L7.35500031,9.86315789 C7.12966752,10.0500108 6.99975938,10.3250424 7,10.6147368 L7,18.0175439 C7,18.5601394 7.44771556,19 8,19 L18,19 C18.5522844,19 19,18.5601394 19,18.0175439 L19,10.6147368 C19.0002406,10.3250424 18.8703325,10.0500108 18.6449997,9.86315789 Z"
        id="backHomeRight-path-1"
      />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-113.000000, -947.000000)">
        <g transform="translate(108.000000, 899.000000)">
          <g transform="translate(0.000000, 48.000000)">
            <g transform="translate(5.000000, 0.000000)">
              <path
                d="M19,26 C26.1797017,26 32,20.1797017 32,13 C32,5.82029825 26.1797017,0 19,0 C14.2135322,0 7.88019884,4.33333333 -5.29354338e-13,13 C7.88019884,21.6666667 14.2135322,26 19,26 Z"
                fill="#006AFF"
                transform="translate(16.000000, 13.000000) scale(-1, 1) translate(-16.000000, -13.000000) "
              />
              <use fill="#FFFFFF" fillRule="nonzero" href="#backHomeRight-path-1" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default BackHomeRight;
